import { render, staticRenderFns } from "./AdditionalServicePage.vue?vue&type=template&id=1a3266b7"
import script from "./AdditionalServicePage.vue?vue&type=script&lang=js"
export * from "./AdditionalServicePage.vue?vue&type=script&lang=js"
import style0 from "./AdditionalServicePage.vue?vue&type=style&index=0&id=1a3266b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports